export async function GetActivityJavamonStatus(idAct: string, userId: string): Promise<any> {
    const url = `${process.env.REACT_APP_API_URL}:8061/jutge/activitats/${idAct}/usuaris/${userId}/javamons/status`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });

        if (response.ok) {
            return await response.json();
        }
        return null;
    } catch (e) {
        console.error("GetActivityJavamonStatus Error:", e);
        return null;
    }
}
